"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIPAwait = exports.getApiIpPe = exports.getIpInfo = exports.getJsonIp = void 0;
const axios_1 = __importDefault(require("axios"));
const localConsole_1 = __importDefault(require("../../utils/localConsole"));
const shuffle_1 = __importDefault(require("../../utils/shuffle"));
const ipAPITimeout = 2500;
const ipAPI = "https://jsonip.com";
// export const getJsonIpPromise = async (ip: string) => {
//   return axios.get(ipAPI, { timeout: ipAPITimeout }).then(({ data }) => {
//     sessionStorage.setItem("userIP", data.ip);
//     ip = data.ip;
//   });
// };
const getJsonIp = async (ip) => {
    const { data } = await axios_1.default.get(ipAPI, { timeout: ipAPITimeout });
    sessionStorage.setItem("userIP", data.ip);
    ip = data.ip;
    return data.ip;
};
exports.getJsonIp = getJsonIp;
const ipAPI_2 = "https://ipinfo.io/json";
// export const getIpInfoPromise = async (ip: string) => {
//   return axios.get(ipAPI_2, { timeout: ipAPITimeout }).then(({ data }) => {
//     sessionStorage.setItem("userIP", data.ip);
//     ip = data.ip;
//   });
// };
const getIpInfo = async (ip) => {
    const { data } = await axios_1.default.get(ipAPI_2, { timeout: ipAPITimeout });
    sessionStorage.setItem("userIP", data.ip);
    ip = data.ip;
    return data.ip;
};
exports.getIpInfo = getIpInfo;
const ipAPI_3 = "https://api.ip.pe.kr";
// export const getApiIpPePromise = async (ip: string) => {
//   return axios.get(ipAPI_3, { timeout: ipAPITimeout }).then(({ data }) => {
//     sessionStorage.setItem("userIP", data);
//     ip = data;
//   });
// };
const getApiIpPe = async (ip) => {
    const { data } = await axios_1.default.get(ipAPI_3, { timeout: ipAPITimeout });
    sessionStorage.setItem("userIP", data);
    ip = data;
    return data;
};
exports.getApiIpPe = getApiIpPe;
const getIPAwait = async (ip) => {
    const getIPList = (0, shuffle_1.default)([exports.getJsonIp, exports.getIpInfo, exports.getApiIpPe]);
    let result = "";
    try {
        result = await getIPList[0](ip);
    }
    catch (err) {
        localConsole_1.default?.error(err, "ipAPI 1");
        try {
            result = await getIPList[1](ip);
        }
        catch (err) {
            localConsole_1.default?.error(err, "ipAPI 2");
            try {
                result = await getIPList[2](ip);
            }
            catch (err) {
                localConsole_1.default?.error(err, "ipAPI 3");
            }
        }
    }
    return result;
};
exports.getIPAwait = getIPAwait;
